<template>
  <div :style="{height: `${height}px`}">
    <legacy
      v-if="legacy"
      :color="color"
      :dark="dark"
      :id="id"
      :size="size"
      :timejump="timejump"
    />
    <player
      v-if="!playlist && !legacy"
      :color="color"
      :dark="dark"
      :height="height"
      :id="id"
      :timejump="timejump"
      :websocket="websocketPath"
    />
    <playlist
      v-if="playlist"
      :color="color"
      :dark="dark"
      :height="height"
      :id="id"
      :websocket="websocketPath"
    />
  </div>
</template>

<script>
import Legacy from '../src/components/Legacy.vue'
import Player from '../src/components/Player.vue'
import Playlist from '../src/components/Playlist.vue'

export default {
  components: {
    Legacy,
    Player,
    Playlist
  },
  props: {
    websocket: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      color: '',
      dark: false,
      id: '',
      episode: {},
      height: this.getHeight(),
      hex: this.color,
      legacy: false,
      playlist: false,
      podcast: {},
      size: 'small',
      timejump: 0
    }
  },
  computed: {
    websocketPath () {
      if (process.env.WEBSOCKET_PATH && process.env.WEBSOCKET_PATH !== '') return process.env.WEBSOCKET_PATH

      return this.websocket
    }
  },
  created () {
    this.color = window.location.hash !== '' ? window.location.hash : window.getUrlParameter('color') || ''
    this.dark = window.getUrlParameter('dark') === 'true'
    this.id = window.id
    this.legacy = window.getUrlParameter('legacy')
    this.playlist = window.getUrlParameter('show')
    this.timejump = this.getTimeJump()

    if (window.getUrlParameter('size')) this.size = window.getUrlParameter('size')

    window.addEventListener('resize', this.setHeight)
    window.addEventListener('hashchange', this.setColor)
  },
  methods: {
    getHeight () {
      return window.innerHeight
    },
    getTimeJump () {
      if (!window.getUrlParameter('t')) return 0

      const t = window.getUrlParameter('t')
      const re = /^(?:(?:(\d+)[:|h])?(\d\d?)[:|m])?(\d\d?)[.\d+]?/i
      const [all, hours, minutes, seconds] = t.match(re)
      let total = 0

      console.log(all)

      // Hours to seconds
      if (hours) total = parseInt(hours) * 3600
      if (minutes) total += parseInt(minutes) * 60
      if (seconds) total += parseInt(seconds)

      return total
    },
    setColor () {
      this.color = window.location.hash
    },
    setHeight () {
      this.height = this.getHeight()
    }
  }
}
</script>

<style lang="scss">
body, html {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
